import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded'
import { OverflowTip } from './Hover/OverflowTip'
import { Pressable } from './Pressable'
import { getNlsString } from '../../nls/nlsRuntime'

import { formatFileSize } from './fileRowHelpers'

/* ---------------------------------------------------------------------------
 * Props
 * ---------------------------------------------------------------------------*/

export type FileRowProps = {
  name: string
  sizeBytes: number
  /** 0–100. When defined, a progress bar is rendered. */
  progress?: number
  error?: boolean
  onRemove?: () => void
}

/* ---------------------------------------------------------------------------
 * FileRow
 * ---------------------------------------------------------------------------*/

export function FileRow({ name, sizeBytes, progress, error, onRemove }: FileRowProps) {
  const removeLabel = getNlsString('NLSCommonFilePickerRemoveFile').replace('{name}', name)

  return (
    <div
      className={[
        'dsFileRow',
        error ? 'is-error' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span aria-hidden="true" style={{ color: 'var(--accent-strong)' }}>
        <InsertDriveFileRoundedIcon fontSize="inherit" />
      </span>

      <div className="dsFileRow__body">
        <OverflowTip label={name}>
          <div className="dsFileRow__name">{name}</div>
        </OverflowTip>
        {progress !== undefined && (
          <div className="dsFileRow__bar">
            <i style={{ width: `${progress}%` }} />
          </div>
        )}
      </div>

      <span className="dsFileRow__meta">{formatFileSize(sizeBytes)}</span>

      {onRemove && (
        <Pressable
          aria-label={removeLabel}
          onClick={onRemove}
          style={{
            background: 'none',
            border: 0,
            padding: '2px',
            cursor: 'pointer',
            color: 'var(--muted)',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <CloseRoundedIcon fontSize="inherit" />
        </Pressable>
      )}
    </div>
  )
}
